export default "__VITE_ASSET__DhsbtpYD__"